export default __webpack_public_path__ + "img/6896408f50b3ed9516341f473dd956d8.svg";